<template>
    <div class="login-page">
        <v-card class="login-card pa-8" elevation="3">
            <div class="text-center mb-6">
                <v-img class="mx-auto mb-4" width="110" contain :src="require('@/assets/main-logo.png')" />
                <div class="text-h6 font-weight-bold">Big CMS</div>
                <div class="text-body-2 grey--text">Sign in to continue</div>
            </div>
            <v-expand-transition>
                <v-alert v-if="showAlert" dense text :type="type" class="text-body-2">
                    {{ message }}
                </v-alert>
            </v-expand-transition>
            <login-form @setAlert="setAlert" />
        </v-card>
    </div>
</template>

<script>
    import LoginForm from '@/forms/LoginForm'

    export default {
        components: { LoginForm },
        data() {
            return {
                showAlert: false,
                message: '',
                type: null
            }
        },
        watch: {
            tab: {
                handler(newval, oldval) {
                    if (newval) {
                        if (this.showAlert !== false) {
                            this.showAlert = false
                        }
                    }
                }
            },
            showAlert: {
                handler(newval, oldval) {
                    if (newval !== oldval) {
                        setTimeout(() => { this.showAlert = false }, 7000)
                    }
                }
            }
        },
        created() {
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
            }
        }
    }
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    margin-top: -56px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 16px 10vh;
    background: linear-gradient(180deg, #fafafa 0%, #eeeeee 100%);
}

.login-card {
    width: 100%;
    max-width: 380px;
    border-top: 4px solid #ff9800 !important;
}
</style>
